<template>
  <div id="categories">   
    <CategoryComponent></CategoryComponent>     
  </div>
</template>

<script>

  import CategoryComponent from '@/components/cust_components/categories_component.vue';
  
  export default {
      name: 'CategoryView',
      data() {
          return {
          }
      },
      components: {     
        CategoryComponent,
      }
  }
</script>